export class TrackedPromise<T> {
  promise: Promise<T>;
  status: 'pending' | 'rejected' | 'resolved' = 'pending';

  constructor(promise: Promise<T>) {
    this.promise = promise;

    this.promise
      .then((r) => (this.status = 'resolved'))
      .catch((e) => {
        this.status = 'rejected';
        throw e;
      });
  }
}
